import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M21.206 15.91c.178-.416-.287-.793-.704-.617A9 9 0 0 1 8.707 3.498c.176-.417-.201-.882-.618-.704A10 10 0 0 0 2 12c0 5.523 4.477 10 10 10 4.135 0 7.684-2.51 9.206-6.09"
    }
  )
);
var SvgMoonFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var MoonFilled_default = SvgMoonFilled;

export { MoonFilled_default as default };
